export default __webpack_public_path__ + "static/cruiselines-vrc-ship-2-337dfb7544533d1c5bcd64c3e7768368.jpg";